// Applies the store accent color site-wide by overriding the hardcoded #F0005A Tailwind classes.
export const ACCENT_PRESETS = [
  { name: "Magenta", value: "#F0005A" },
  { name: "Navy", value: "#00133F" },
  { name: "Biru", value: "#2563EB" },
  { name: "Hijau", value: "#059669" },
  { name: "Oranye", value: "#EA580C" },
  { name: "Ungu", value: "#7C3AED" },
  { name: "Merah", value: "#DC2626" },
  { name: "Emas", value: "#B45309" },
];

export function applyAccent(accent) {
  if (!accent || !/^#[0-9a-fA-F]{6}$/.test(accent)) return;
  const a = accent;
  const css = `
:root{--brand-accent:${a};}
.bg-\\[\\#F0005A\\]{background-color:${a}!important;}
.hover\\:bg-\\[\\#F0005A\\]:hover{background-color:${a}!important;}
.text-\\[\\#F0005A\\]{color:${a}!important;}
.hover\\:text-\\[\\#F0005A\\]:hover{color:${a}!important;}
.border-\\[\\#F0005A\\]{border-color:${a}!important;}
.hover\\:border-\\[\\#F0005A\\]:hover{border-color:${a}!important;}
.ring-\\[\\#F0005A\\]{--tw-ring-color:${a}!important;}
.focus-visible\\:ring-\\[\\#F0005A\\]\\/50:focus-visible{--tw-ring-color:${a}80!important;}
.focus\\:ring-\\[\\#F0005A\\]\\/50:focus{--tw-ring-color:${a}80!important;}
.bg-\\[\\#F0005A\\]\\/10{background-color:${a}1A!important;}
.bg-\\[\\#F0005A\\]\\/5{background-color:${a}0D!important;}
.bg-\\[\\#F0005A\\]\\/20{background-color:${a}33!important;}
.border-\\[\\#F0005A\\]\\/20{border-color:${a}33!important;}
.ring-\\[\\#F0005A\\]\\/30{--tw-ring-color:${a}4D!important;}
.data-\\[state\\=checked\\]\\:bg-\\[\\#F0005A\\][data-state="checked"]{background-color:${a}!important;}
.data-\\[state\\=checked\\]\\:border-\\[\\#F0005A\\][data-state="checked"]{border-color:${a}!important;}
`;
  let el = document.getElementById("brand-theme");
  if (!el) { el = document.createElement("style"); el.id = "brand-theme"; document.head.appendChild(el); }
  el.textContent = css;
}
